<template>
  <div>
    <div
      v-for="category of categories"
      :key="category.title"
    >
      <v-list
        v-if="category.children"
        shaped
        dense
      >
        <v-divider />
        <v-list-item>
          <v-list-item-icon>
            <v-icon>{{ category.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="black--text text-overline">
            {{ category.title }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-for="child of category.children"
          :key="child.title"
          :to="{name: child.route}"
        >
          <v-list-item-title class="ml-14">
            {{ child.title }}
          </v-list-item-title>
          <v-list-item-icon>
            <v-icon>{{ child.icon }}</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>

      <v-list
        v-if="!category.children"
        dense
        shaped
      >
        <v-list-item
          :to="{name: category.route}"
        >
          <v-list-item-icon>
            <v-icon>{{ category.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ category.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettingsNav',

  data () {
    return {
      categories: [
        { icon: 'mdi-cog', route: 'settings-site', title: 'Site' },
        { icon: 'security', route: 'settings-auth', title: 'Auth' },
        { icon: 'checklist', route: 'settings-checklists', title: 'Checklists' },
        { icon: 'stream', route: 'settings-integration', title: 'Integrations' },
        { icon: 'account_box', route: 'settings-users', title: 'Users' },
        { icon: 'groups', route: 'settings-teams', title: 'Teams' },
        { icon: 'tag', route: 'settings-shared-tags', title: 'Tags' },
        { icon: 'mdi-tools', route: 'settings-system-management', title: 'System Management' },
        { icon: 'mdi-alpha-s-box-outline', route: 'settings-subscription', title: 'Law Lab Subscription' },
        {
          children: [
            { icon: 'language', route: 'settings-party-languages', title: 'Languages' },
            { icon: 'language', route: 'settings-party-ethnicities', title: 'Ethnicities' },
            { icon: 'badge', route: 'settings-party-roles', title: 'Roles' },
          ],

          icon: 'person',
          route: 'settings-party',
          title: 'Party',
        },
        {
          children: [
            { icon: 'assignment', route: 'settings-legal-case-types', title: 'Case Types' },
            { icon: 'place', route: 'settings-legal-case-locations', title: 'Locations' },
            { icon: 'assignment_ind', route: 'settings-legal-case-preference-categories', title: 'Preference Categories' },
            { icon: 'archive', route: 'settings-legal-case-closing-reasons', title: 'Closing Reasons' },
            { icon: 'forward_to_inbox', route: 'settings-legal-case-engagement-letter', title: 'Engagement Letter' },
            { icon: 'settings_suggest', route: 'settings-legal-case-other', title: 'Other' },
          ],

          icon: 'work',
          route: 'settings-legal-cases',
          title: 'Legal Cases',
        },
        {
          children: [
            { icon: 'library_add_check', route: 'settings-docket-entry-types', title: 'Entry Types' },
            { icon: 'content_copy', route: 'settings-docket-entry-document-sets', title: 'Document Sets' },
            { icon: 'mdi-message-cog', route: 'settings-docket-entry-notifications', title: 'Notification Triggers' },
            { icon: 'mdi-script-text', route: 'settings-docket-entry-notification-template', title: 'Notification Templates' },
            { icon: 'settings_suggest', route: 'settings-docket-entry-other', title: 'Other' },
          ],

          icon: 'check_circle_outline',
          route: 'settings-docket-entries',
          title: 'Docket Entries',
        },
      ],
    }
  },

  computed: {
    categoriesWithChildren () {
      return this.categories.filter(c => c.children)
    },
  },

  methods: {
    navigateTo (category) {
      if (category.active) return

      this.$router.push({ name: category.route })
    },
  },
}
</script>

<style scoped lang="scss">
  .d-sticky {
    position: sticky !important;
    top: 72px !important;
    z-index: 1 !important;
  }
</style>
